import { Injectable } from '@angular/core';
import { ThemesService } from '../themes/themes.service';
import { MeteorUser, MeteorUserLayout } from '../../../../../backend/server/data-models/meteor-user/meteor-user';

/**
 * Az alkalmazás alapértelemezett nyelve. Csak olyan érték lehet, ami be van regisztrálva a TranslatorService-ben!
 */
export const DEFAULT_LANGUAGE: string = 'hu';

@Injectable({
    providedIn: "root"
})
export class SettingsService {

    private app: any;

    constructor() {
        // App Settings
        // -----------------------------------
        this.app = {
            name: 'Kérdőív',
            description: 'Kérdőívkezelő rendszer',
            year: ((new Date()).getFullYear())
        };
    }

    getAppSetting(name) {
        return name ? this.app[name] : this.app;
    }

    getUserSetting(name) {
        let user = Meteor.user();
        if (!user || !user.profile) return;
        return name ? Meteor.user().profile[name] : Meteor.user().profile;
    }

    getLayoutSetting(name) {
        let user = Meteor.user();
        if (!user || !user.profile) return null;
        if (!user.profile.layout) user.profile.layout = this.createDefaultLayout();
        return name ? user.profile.layout[name] : user.profile.layout;
    }

    setAppSetting(name, value) {
        let user = Meteor.user();
        if (!user) return;

        if (typeof this.app[name] !== 'undefined') {
            this.app[name] = value;
        }
    }

    setUserSetting(name, value) {
        let user = Meteor.user();
        if (user && user.profile && typeof user.profile[name] !== 'undefined' && user.profile[name] !== value) {
            user.profile[name] = value;
            // console.warn("SET USER PROFILE"); console.warn(user.profile);
            Meteor.users.update({ _id: user._id }, {
                $set: {
                    "profile": user.profile
                }
            });
            return value;
        }
        return null;
    }

    setLayoutSetting(name, value) {
        let user = Meteor.user();
        if (user && user.profile) {
            if (!user.profile.layout) user.profile.layout = this.createDefaultLayout();

            if (user.profile.layout[name] !== 'undefined' && user.profile.layout[name] !== value) {
                // console.warn("SETTINGS SET: " + name); console.warn(value);
                user.profile.layout[name] = value;
                Meteor.users.update({ _id: user._id }, {
                    $set: {
                        "profile.layout": user.profile.layout
                    }
                });
                return value;
            }
        }
        return null;
    }

    toggleLayoutSetting(name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }

    createDefaultLayout(): MeteorUserLayout {
        return {
            isFixed: false,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: ThemesService.DEFAULT_THEME,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            offsidebarOpen: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp',
            hideSidebarUserBlock: false,
        };
    }
}
